module.exports = __webpack_public_path__ + "img/map.474258a7.png";